import React, { useContext, useState, useEffect } from "react";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import Select from "react-select";
import Swal from "sweetalert2";
import axios from "axios";
import GlobalContext from "../connections/GlobalContext";
import image1 from "../image/replacement.png";
import DataTable from "react-data-table-component";
import image2 from "../image/spare-parts.png";
import Head_data from "../components/Head_data";
import Return_sales_stock from "./Sales_return";
import PurchaseReturn from "./purchase_return";
import engineGif from "../image/engine.gif";
import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";

const Purchase = ({ theme }) => {
  const [showAddSpareModal, setShowAddSpareModal] = useState(false);
  const [showAddQuantityModal, setShowAddQuantityModal] = useState(false);
  const [spares, setSpares] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [spare, setSpare] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [vendor, setVendor] = useState("");
  const [addedSpares, setAddedSpares] = useState([]);
  const [selectedSpares, setSelectedSpares] = useState([]);
  const { globalValue } = useContext(GlobalContext);
  const [pay_mode, setPay_mode] = useState("");
  const [isEditingPrice, setIsEditingPrice] = useState(false);
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [spareOptions, setSpareOptions] = useState([]);
  const [temp_spare, setTemp_spare] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bill_no, setBill_no] = useState("");
  const [mode, setMode] = useState("");
  const [gst_amount, setGst_amount] = useState(0);

  const navigate = useNavigate();

  const [date, setDate] = useState(DateTime.now().toISODate());

  const options = vendors.map((vendor) => ({
    value: vendor[0],
    label: vendor[1],
  }));

  const spareOptionsData = spares.map((spare) => ({
    value: spare[0],
    label: spare[1],
  }));

  useEffect(() => {
    const data = sessionStorage.getItem("selected_spare");

    if (data) {
      try {
        const parsedData = JSON.parse(data);
        setSelectedSpares(parsedData);
      } catch (error) {
        console.error(
          "Failed to parse selected_spare from sessionStorage:",
          error
        );
        setSelectedSpares([]);
      }
    }

    sessionStorage.setItem("selected_spare", JSON.stringify([]));
  }, []);

  const fetchSpares = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/get_spares`,
        {
          data: sessionStorage.getItem("branch"),
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setSpares(response.data);
    } catch (error) {
      console.error("Error fetching spares:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchSpareDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/spareLog`,
        {
          branch: sessionStorage.getItem("branch"),
        },
        {
          headers: { "x-access-token": sessionStorage.getItem("token") },
        }
      );

      const options = response.data.map((spare) => ({
        value: spare["spare_id"],
        label: spare["spare_name"],
        model: spare["model"],
        quantity: spare["quantity"],
      }));

      setSpareOptions(options);
    } catch (error) {
      console.error("Error fetching spare log:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchVendors = () => {
    setLoading(true);

    const branch = sessionStorage.getItem("branch");

    fetch(
      `${globalValue}/get_vendors?data=${encodeURIComponent(branch)}`,
      {
        method: "GET",
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((dat) => {
        setVendors(dat);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => setLoading(false));
  };

  const [purchase, setPurchase] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(purchase);
  const [sdate, setSdate] = useState("");
  const [edate, setEdate] = useState("");

  useEffect(() => {
    const filteredData = purchase.filter((purchase) => {
      const billMatch = (purchase["bill_no"] || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const vendorMatch = (purchase["vendor_name"] || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase());

      const purchaseDate = new Date(purchase["date"]);
      const startDate = sdate ? new Date(sdate) : null;
      const endDate = edate ? new Date(edate) : null;

      const dateInRange =
        (!startDate || purchaseDate >= startDate) &&
        (!endDate || purchaseDate <= endDate);

      return (billMatch || vendorMatch) && dateInRange;
    });

    setFiltered(filteredData);
  }, [searchTerm, purchase, sdate, edate]);

  const fetchPurchase = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/purchase`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setPurchase(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSpares();
    fetchVendors();
    fetchPurchase();
    fetchSpareDetails();
  }, []);

  const handlePay = async (id, total, paid) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/pay_amt`,
        {
          id,
          total,
          paid,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      if (response.data.message === "success") {
        Swal.fire(
          "Success",
          "Amount paid  Rs." + paid + " successfully",
          "success"
        );
        setShow2(false);
        fetchPurchase();
      } else {
        Swal.fire("Error", response.data.message, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        width: "100%",
        border:
          theme === "dark"
            ? "solid 1px rgb(63, 62, 62)"
            : "solid 1px rgb(226, 232, 240)",
      },
    },
    headCells: {
      style: {
        backgroundColor:
          theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
        color: theme === "dark" ? "white" : "black",
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        color: theme === "dark" ? "white" : "black",
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        border:
          theme === "dark"
            ? "solid 1px rgb(63, 62, 62)"
            : "solid 1px rgb(255, 255, 255)",
      },
    },
    pagination: {
      style: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        color: theme === "dark" ? "white" : "black",
        borderTop:
          theme === "dark" ? "solid 1px white" : "solid 1px rgb(226, 232, 240)",
      },
      pageButtonsStyle: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        color: theme === "dark" ? "white" : "black",
        fill: theme === "dark" ? "white" : "black",
        "&:hover": {
          backgroundColor:
            theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)",
        },
      },
    },
  };

  const [show1, setShow1] = useState(false);
  const [spare_data, setSpare_date] = useState([]);
  const [paid_amt, setPaid_amt] = useState(0);
  const [amt_to_pay, setAmt_to_pay] = useState("");
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [temp_id, setTemp_id] = useState("");
  const [temp_id1, setTemp_id1] = useState("");
  const [temp_total, setTemp_total] = useState("");
  const [status, setStatus] = useState("");
  const [total_amt, setTotal_amt] = useState(0);
  const [base_amount, setBase_amount] = useState(0);

  const handledelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This purchase will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await axios.post(`${globalValue}/purchase_delete`, {
          purchase_id: id,
        });

        if (response.data.success === 1) {
          Swal.fire("Deleted!", "Purchase deleted successfully.", "success");
          fetchPurchase();
        } else {
          Swal.fire("Error", response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Something went wrong while deleting.", "error");
      }
    }
  };

  const columns = [
    { name: "Bill no", selector: (row) => row.bill_no, width: "80px" },
    { name: "Vendor", selector: (row) => row.vendor_name },
    { name: "Total", selector: (row) => row.total_amount },
    // { name: "Paid", selector: (row) => row.amount_paid },
    // { name: "Pending", selector: (row) => row.total_amount - row.amount_paid },
    {
      name: "Date",
      selector: (row) => {
        const d = new Date(row.date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      },
    },
    {
      name: "Action",
      center: true,
      width: "250px",
      cell: (row) => (
        <div className="flex gap-2 w-full">
          <button
            className="p-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
            onClick={() => {
              setShow1(true);
              setSpare_date(row.spares);
              setStatus(row.status === "1" ? "Returned" : "");
            }}
          >
            <i className="fa fa-eye"></i>
          </button>
          {row.status !== "1" ? (
            <button
              className="p-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
              onClick={() => {
                setTemp_id1(row.id);
                setTemp_spare(row.spares);
                console.log(row.spares);
                setShow3(true);
              }}
            >
              Return
            </button>
          ) : null}

          <button
            onClick={() => {
              setShowAddQuantityModal(true);
              setTemp_id(row.id);
              setPaid_amt(row.amount_paid);
              console.log("vendor:", row.vendor);
              setVendor(row.vendor);
              setVendor_id(row.vendor_id);
              setBill_no(row.bill_no);
              setSelectedSpares(row.spares);
              setGst_amount(row.gst_amount);
              setDate(new Date(row.date).toISOString().split("T")[0]);
              setPay_mode(row.pay_mode);
              setMode("edit");
              const total = row.spares.reduce((sum, item) => {
                const price = parseFloat(item.price) || 0;
                const quantity = parseFloat(item.quantity) || 0;
                return sum + price * quantity;
              }, 0);
              console.log(total);
              setBase_amount(total);
              setTotal_amt(
                parseFloat((Number(total) + Number(row.gst_amount)).toFixed(2))
              );
            }}
            className="p-2 text-white border bg-gray-700 hover:bg-gray-800 rounded-md shadow-xl"
          >
            <i className="fa fa-edit"></i>
          </button>
          <button
            onClick={() => handledelete(row.id)}
            className="p-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
          >
            <i className="fa fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const [vendor_id, setVendor_id] = useState("");
  const handleAddQuantity = async () => {
    if (!pay_mode) {
      Swal.fire("Error", "Enter All Fields", "error");
      return;
    }
    if (paid_amt > total_amt) {
      Swal.fire("Error", "Paid amount is greater than total amount", "error");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/purchase_quantity`,
        {
          spares: selectedSpares,
          vendor: vendor_id,
          branch: sessionStorage.getItem("branch"),
          total_amt,
          gst_amount,
          paid_amt: paid_amt ? paid_amt : 0,
          pay_mode,
          bill_no,
          date,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      if (response.data === "success") {
        Swal.fire("Success", "Spare quantities added successfully", "success");
        setShowAddQuantityModal(false);
        setSelectedSpares([]);
        fetchPurchase();
      } else {
        Swal.fire("Error", "Failed to add spare quantities", "error");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleEditQuantity = async () => {
    if (!pay_mode) {
      Swal.fire("Error", "Enter All Fields", "error");
      return;
    }
    const paid = parseFloat(paid_amt || 0);
    const total = parseFloat(total_amt || 0);

    if (paid > total) {
      console.log(paid, total);
      Swal.fire("Error", "Paid amount is greater than total amount", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/purchase_edit`,
        {
          spares: selectedSpares,
          vendor: vendor,
          branch: sessionStorage.getItem("branch"),
          total_amt,
          gst_amount,
          demo: "alagesh",
          paid_amt: paid_amt ? paid_amt : 0,
          pay_mode,
          bill_no,
          date,
          temp_id,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );
      if (response.data === "success") {
        Swal.fire("Success", "Spare quantities added successfully", "success");
        setShowAddQuantityModal(false);
        setSelectedSpares([]);
        fetchPurchase();
      } else {
        Swal.fire("Error", "Failed to add spare quantities", "error");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const handleAddSpareQuantity = (
    spare,
    quantity,
    price,
    vendor,
    brand,
    model
  ) => {
    if (!spare || !quantity || !price || !vendor || !brand || !model) {
      Swal.fire("Error", "Enter All Fields", "error");
      return;
    }

    let name = "",
      vendor_name = "";

    // Spare name lookup
    for (let i = 0; i < spares.length; i++) {
      if (spare === spares[i][0]) {
        name = spares[i][1];
      }
    }

    // Vendor name lookup
    for (let i = 0; i < vendors.length; i++) {
      if (parseInt(vendor) === vendors[i][0]) {
        vendor_name = vendors[i][1];
      }
    }

    // Convert numeric inputs to float
    const qty = parseFloat(quantity);
    const pr = parseFloat(price);

    if (isNaN(qty) || isNaN(pr)) {
      Swal.fire("Error", "Quantity and Price must be numeric", "error");
      return;
    }

    // Calculate total price correctly (supports decimals)
    const totalPrice = pr * qty;

    // Check duplicate (same spare + brand + model)
    const duplicate = selectedSpares.some(
      (item) =>
        String(item.spareId) === String(spare) &&
        item.brand === brand &&
        item.model === model
    );

    if (duplicate) {
      Swal.fire(
        "Duplicate Entry",
        "This spare with the same brand and model is already added!",
        "warning"
      );
      return;
    }

    const updatedSpares = [
      ...selectedSpares,
      {
        spareId: spare,
        name,
        quantity: qty,
        price: pr,
        vendor,
        vendor_name,
        totalPrice,
        brand,
        model,
      },
    ];

    setSelectedSpares(updatedSpares);

    // Grand total with decimals
    const newTotal = updatedSpares.reduce(
      (sum, s) => sum + (parseFloat(s.totalPrice) || 0),
      0
    );

    setBase_amount(newTotal);
    setTotal_amt(parseFloat(newTotal) + parseFloat(gst_amount || 0));

    // Reset
    setSpare(null);
    setQuantity("");
    setPrice("");
    setBrand("");
    setModel("");
  };


  return (
    <div
      className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${theme === "dark"
        ? "bg-gray-900 text-white"
        : "bg-gray-100 text-gray-800"
        }`}
    >
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
          <img src={engineGif} alt="Loading..." className="w-24 h-24" />
        </div>
      )}
      <div
        className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${theme === "dark"
          ? "bg-gray-800 text-gray-200"
          : "bg-white text-gray-800"
          }`}
      >
        {!show3 ? (
          <>
            <div className="w-full flex justify-between text-gray-600">
              <div className="flex flex-wrap items-center gap-4 mb-4">
                <Head_data
                  data="Purchase"
                  font=""
                  size="3xl"
                  color={theme === "dark" ? "text-gray-200" : "text-gray-800"}
                />

                <div className="flex flex-col">
                  <Label value="Start Date" className="mb-1 text-sm" />
                  <input
                    type="date"
                    value={sdate}
                    onChange={(e) => setSdate(e.target.value)}
                    className="border rounded px-3 py-1"
                  />
                </div>

                <div className="flex flex-col">
                  <Label value="End Date" className="mb-1 text-sm" />
                  <input
                    type="date"
                    value={edate}
                    onChange={(e) => setEdate(e.target.value)}
                    className="border rounded px-3 py-1"
                  />
                </div>
              </div>

              <button
                onClick={() => {
                  setShowAddQuantityModal(true);
                  setSpare(null);
                  setQuantity("");
                  setPrice("");
                  setVendor("");
                  setTotal_amt("");
                  setPaid_amt(0);
                  setPay_mode("");
                  setMode("add");
                  setBase_amount(0);
                  setGst_amount(0);

                }}
                className=" h-12 px-4 py-1 text-white bg-blue-600 rounded hover:bg-blue-700 md:mt-2"
              >
                Add Quantity
              </button>
            </div>
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
            />
            <div className="py-6 md:px-2">
              <DataTable
                columns={columns}
                data={filtered}
                customStyles={customStyles}
                pagination
              />
            </div>
          </>
        ) : (
          <PurchaseReturn
            id={temp_id1}
            spare={temp_spare}
            fetchPurchase={fetchPurchase}
            show3={setShow3}
          />
        )}
        <Modal
          show={showAddQuantityModal}
          onClose={() => {
            setShowAddQuantityModal(false);
            setSelectedSpares([]);
          }}
          size="7xl"
        >
          <Modal.Header className="flowbite-modal-h">
            <div className="w-full flex flex-col md:flex-row md:justify-between gap-4">
              {mode !== "edit" ? (
                <p className="text-lg font-semibold">
                  Add Quantity to Existing Spare
                </p>
              ) : (
                <p className="text-lg font-semibold">Edit purchase bill</p>
              )}

              <div className="flex  flex-col sm:flex-row md:ms-auto gap-4 w-full md:w-full">
                <div className="w-full sm:w-auto">
                  <Label>Paid Amount</Label>
                  <TextInput
                    placeholder="Enter Amount"
                    type="number"
                    value={paid_amt}
                    onChange={(e) => setPaid_amt(e.target.value)}
                    className="w-full sm:w-auto"
                    color="white"
                  />
                </div>
                <div className="w-full sm:w-auto">
                  <Label>Date</Label>
                  <TextInput
                    placeholder="Enter Date"
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="w-full sm:w-auto"
                    color="white"
                  />
                </div>
                <div className="w-full sm:w-auto flex flex-col gap-2">
                  <Label>Pay Mode</Label>
                  <select
                    value={pay_mode}
                    onChange={(e) => setPay_mode(e.target.value)}
                    className="w-full sm:w-auto border rounded px-2 py-1 text-12"
                  >
                    <option value="" disabled>
                      Enter Pay Mode
                    </option>
                    <option value="cash">Cash</option>
                    <option value="cheque">Cheque</option>
                  </select>

                </div>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div className="flex flex-wrap">
              <div className="form1 w-full md:w-1/2 md:px-2">
                <form>
                  <div className="grid grid-cols-1 gap-4">
                    <div className="flex w-full gap-4">
                      {console.log("OOO", vendors)}
                      <div>
                        <Label>Vendor</Label>
                        <Select
                          value={
                            vendors
                              ?.map(([id, name]) => ({ value: Number(id), label: name }))
                              .find((option) => option.value === Number(vendor)) || null
                          }
                          onChange={(selectedOption) => {
                            if (!selectedOption) return;

                            const newVendorId = Number(selectedOption.value);
                            const newVendorName = selectedOption.label;

                            setVendor(newVendorId);
                            setVendor_id(newVendorId);

                            setSelectedSpares((prev) =>
                              prev.map((sp) => ({
                                ...sp,
                                vendor: newVendorId,
                                vendor_name: newVendorName,
                              }))
                            );
                          }}
                          options={vendors?.map(([id, name]) => ({
                            value: Number(id),
                            label: name,
                          }))}
                          placeholder="Select Vendor"
                          isSearchable
                          className="w-full w-96"
                          classNamePrefix="react-select"
                        />


                      </div>

                      <div>
                        <Label>Bill no</Label>
                        <TextInput
                          placeholder="Enter Bill no"
                          type="text"
                          value={bill_no}
                          onChange={(e) => setBill_no(e.target.value)}
                          color="white"
                        />
                      </div>
                    </div>

                    <hr />

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div>
                        <Label>Select Spare</Label>
                        <Select
                          value={spareOptionsData.find(
                            (option) => option.value === spare
                          ) || null}
                          onChange={(e) => {
                            console.log("RRR", e);
                            setSpare(e?.value);
                            setBrand("");
                            setModel("");
                            sessionStorage.setItem("spare_id", e?.value);
                          }}
                          options={spareOptionsData}
                          color="white"
                        ></Select>
                      </div>

                      <div>
                        <Label className="block text-gray-700 text-sm font-medium mb-1">
                          Select Brand
                        </Label>
                        <div className="flex gap-2">
                          <select
                            value={brand}
                            onChange={(e) => {
                              setBrand(e.target.value);
                              setModel("");
                            }}
                            className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                          >
                            <option value="" disabled>
                              Select Brand
                            </option>
                            {spareOptions
                              .find((s) => s.value === spare)
                              ?.model?.map((item) => item.brand)
                              .filter(
                                (brand, index, self) =>
                                  self.indexOf(brand) === index
                              )
                              .map((b) => (
                                <option
                                  key={b}
                                  value={b}
                                  className="text-gray-700 p-1"
                                >
                                  {b}
                                </option>
                              ))}
                          </select>
                          <button
                            className="px-2 py-1 text-xl bg-blue-500 text-white  rounded-md shadow-md"
                            onClick={() => {
                              sessionStorage.setItem(
                                "selected_spare",
                                JSON.stringify(selectedSpares)
                              );
                              sessionStorage.setItem("status", 1);
                              navigate("/spares");
                            }}
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div>
                        <Label className="block text-gray-700 text-sm font-medium mb-1">
                          Select Model
                        </Label>
                        <select
                          value={model}
                          onChange={(e) => setModel(e.target.value)}
                          className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        >
                          <option value="" disabled>
                            Select Model
                          </option>
                          {spareOptions
                            .find((s) => s.value === spare)
                            ?.model?.filter((item) => item.brand === brand)
                            .map((item) => (
                              <option
                                key={item.model}
                                value={item.model}
                                className="text-gray-700 p-1"
                              >
                                {item.model}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div>
                        <Label>Quantity</Label>
                        <TextInput
                          placeholder="Enter Quantity"
                          type="number"
                          value={quantity}
                          onChange={(e) => setQuantity(e.target.value)}
                          color="white"
                        />
                      </div>

                      <div>
                        <Label>Price</Label>
                        <TextInput
                          placeholder="Enter Price"
                          type="number"
                          value={price}
                          onChange={(e) => setPrice(e.target.value)}
                          color="white"
                        />
                      </div>
                    </div>

                    <hr />
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4"></div>
                  </div>

                  <div className="flex gap-4 mt-4">
                    <Button
                      color="blue"
                      onClick={() =>
                        handleAddSpareQuantity(
                          spare,
                          quantity,
                          price,
                          vendor,
                          brand,
                          model
                        )
                      }
                    >
                      Add Spare
                    </Button>
                    <Button
                      color="gray"
                      onClick={() => {
                        setSpare(null);
                        setQuantity("");
                        setPrice("");
                        setVendor("");
                        setPaid_amt(0);
                        setPay_mode("");
                        setBrand("");
                        setModel("");
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </form>
              </div>

              <div className="form2 w-full md:w-1/2 py-2">
                <div className="overflow-auto max-h-[300px]">
                  <table className="w-full table-auto text-sm text-left text-gray-600">
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="px-4 py-2">Spare Name</th>
                        <th className="px-4 py-2">Brand</th>
                        <th className="px-4 py-2">Model</th>
                        <th className="px-4 py-2">Quantity</th>
                        <th className="px-4 py-2">Price</th>
                        <th className="px-4 py-2">Total</th>
                        <th className="px-4 py-2">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedSpares.map((spare, index) => (
                        <tr key={index} className="border-b">
                          <td className="px-4 py-2">{spare.name}</td>
                          <td className="px-4 py-2">{spare.brand}</td>
                          <td className="px-4 py-2">{spare.model}</td>
                          <td className="px-4 py-2">{spare.quantity}</td>
                          <td className="px-4 py-2">{spare.price}</td>
                          <td className="px-4 py-2">
                            {parseFloat(spare.quantity) *
                              parseFloat(spare.price)}
                          </td>
                          <td className="px-4 py-2 flex gap-2">
                            <Button
                              color="yellow"
                              size="xs"
                              className="text-gray-700"
                              onClick={() => {
                                setSpare(spare.spareId);
                                setBrand(spare.brand);
                                setModel(spare.model);
                                setQuantity(spare.quantity);
                                setPrice(spare.price);

                                const updatedSpares = selectedSpares.filter(
                                  (_, i) => i !== index
                                );
                                setSelectedSpares(updatedSpares);
                                const newTotal = updatedSpares.reduce(
                                  (sum, spare) =>
                                    sum + (parseFloat(spare.totalPrice) || 0),
                                  0
                                );
                                setBase_amount(newTotal);
                                setTotal_amt(newTotal + gst_amount);
                              }}
                            >
                              Edit
                            </Button>

                            <Button
                              color="red"
                              size="xs"
                              className="text-gray-700"
                              onClick={() => {
                                const updatedSpares = selectedSpares.filter(
                                  (_, i) => i !== index
                                );
                                setSelectedSpares(updatedSpares);
                                const newTotal = updatedSpares.reduce(
                                  (sum, spare) =>
                                    sum + (parseFloat(spare.totalPrice) || 0),
                                  0
                                );
                                setBase_amount(newTotal);
                                setTotal_amt(parseFloat(newTotal) + parseFloat(gst_amount));

                                Swal.fire(
                                  "Deleted",
                                  "Spare quantity removed successfully",
                                  "success"
                                );
                              }}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-h">
            <div className="flex flex-col md:flex-row justify-between items-center w-full gap-4">
              <div className="flex flex-wrap gap-4">
                <Button
                  color="gray"
                  onClick={() => setShowAddQuantityModal(false)}
                >
                  Cancel
                </Button>
                {mode !== "edit" ? (
                  <Button
                    color="green"
                    className="text-gray-700"
                    onClick={() => handleAddQuantity()}
                  >
                    Submit Quantities
                  </Button>
                ) : (
                  <Button
                    color="green"
                    className="text-gray-700"
                    onClick={() => handleEditQuantity()}
                  >
                    Update Bill
                  </Button>
                )}
              </div>

              <div className="tot flex items-center gap-2 text-lg font-semibold">
                <div className="lb">
                  <label htmlFor="">Total Gst Amount:</label>
                  <TextInput
                    placeholder="Enter gst amount"
                    type="number"
                    value={gst_amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      setGst_amount(value);
                      const gst = parseFloat(value) || 0;
                      const base = parseFloat(base_amount) || 0;
                      setTotal_amt(base + gst);
                    }}
                    color="white"
                  />
                </div>

                <p>Grand Total Rs. {total_amt ?? 0}</p>
              </div>

            </div>
          </Modal.Footer>
        </Modal>

        <Modal show={show1} onClose={() => setShow1(false)}>
          <Modal.Header className="flowbite-modal-h">
            Spare Details
          </Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div className="overflow-x-auto">
              <table className="min-w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 p-2">Name</th>
                    <th className="border border-gray-300 p-2">Brand</th>
                    <th className="border border-gray-300 p-2">Model</th>
                    <th className="border border-gray-300 p-2">Quantity</th>
                    <th className="border border-gray-300 p-2">Price</th>
                    <th className="border border-gray-300 p-2">Vendor Name</th>
                  </tr>
                </thead>
                <tbody>
                  {spare_data.map((spare, index) => (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className="border border-gray-300 p-2">
                        {spare.name}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {spare.brand}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {spare.model}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {spare.quantity}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {spare.price}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {spare.vendor_name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show2} onClose={() => setShow2(false)}>
          <Modal.Header className="flowbite-modal-h">Pay Amount</Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div className="overflow-x-auto">
              <p>Total amount:{amt_to_pay} </p>

              <div>
                <Label>Price</Label>
                <TextInput
                  placeholder="Enter Price"
                  type="number"
                  value={paid_amt}
                  max={parseFloat(amt_to_pay)}
                  onChange={(e) => setPaid_amt(e.target.value)}
                  color="white"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-h">
            <Button color="gray" onClick={() => setShow2(false)}>
              Cancel
            </Button>
            <Button
              disabled={paid_amt > amt_to_pay}
              className="text-gray-700"
              color="green"
              onClick={() => {
                handlePay(temp_id, temp_total, paid_amt);
              }}
            >
              Pay
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Purchase;
